"use strict";
exports.__esModule = true;
exports.DesignerAssetsBuilder = void 0;
var DesignerAssetsBuilder = /** @class */ (function () {
    function DesignerAssetsBuilder(productionPlanAssets) {
        this.designerAssets = productionPlanAssets;
    }
    DesignerAssetsBuilder.initialiseWithDesignerAssets = function (designerAssets) {
        return new DesignerAssetsBuilder(designerAssets);
    };
    DesignerAssetsBuilder.initialiseWithEmptyAssets = function () {
        return DesignerAssetsBuilder.initialiseWithDesignerAssets({
            fonts: [],
            symbols: [],
            symbolCollections: [],
            pieces: [],
            accessories: []
        });
    };
    DesignerAssetsBuilder.prototype.concat = function (otherAssets) {
        this.designerAssets = {
            fonts: this.designerAssets.fonts.concat(otherAssets.fonts),
            symbols: this.designerAssets.symbols.concat(otherAssets.symbols),
            symbolCollections: this.designerAssets.symbolCollections.concat(otherAssets.symbolCollections),
            pieces: this.designerAssets.pieces.concat(otherAssets.pieces),
            accessories: this.designerAssets.accessories.concat(otherAssets.accessories)
        };
        return this;
    };
    DesignerAssetsBuilder.prototype.addFont = function (font) {
        this.designerAssets.fonts.push(font);
        return this;
    };
    DesignerAssetsBuilder.prototype.addSymbol = function (symbol) {
        this.designerAssets.symbols.push(symbol);
        return this;
    };
    DesignerAssetsBuilder.prototype.addSymbolCollection = function (symbolCollection) {
        this.designerAssets.symbolCollections.push(symbolCollection);
        return this;
    };
    DesignerAssetsBuilder.prototype.addPiece = function (piece) {
        this.designerAssets.pieces.push(piece);
        return this;
    };
    DesignerAssetsBuilder.prototype.addAccessory = function (accessory) {
        this.designerAssets.accessories.push(accessory);
        return this;
    };
    DesignerAssetsBuilder.prototype.build = function () {
        return this.designerAssets;
    };
    return DesignerAssetsBuilder;
}());
exports.DesignerAssetsBuilder = DesignerAssetsBuilder;
